/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import Image from "components/Image/CustomImage";

import Tooltip from "@mui/material/Tooltip";

import { makeStyles } from "tss-react/mui";

import Avatar from "@mui/material/Avatar";

import { PLACEHOLDER_IMAGE_PATH } from "settings/global-website-config";

import { grayColor } from "../../assets/jss/nextjs-material-kit-pro";

const width = 400;
const useStyles = makeStyles()((theme) => ({
  productAvatar: {
    backgroundColor: theme.palette.common.white,
  },
  notCurrentItemBorder: {
    border: `1px solid ${grayColor[0]}`,
  },
  currentItemBorder: {
    border: `1px solid ${theme.palette.primary.main}`,
  },
  imagePopover: {
    height: 400,
    minWidth: width,
    backgroundColor: theme.palette.common.white,
    padding: 0,
    margin: 0,
    borderRadius: theme.spacing(1),
    boxShadow: theme.shadows[8],

    "& img": { borderRadius: theme.spacing(1) },
  },
}));

export default function ProductAvatar(props) {
  const { classes } = useStyles();

  const { product, currentProduct } = props;

  return (
    <Tooltip
      arrow
      disableHoverListener={!product.featuredImage?.node.sourceUrl}
      title={
        <Image
          width={width}
          height={width}
          style={{ objectFit: "contain" }}
          src={product.featuredImage?.node.sourceUrl || PLACEHOLDER_IMAGE_PATH}
          alt={`Close up image of ${product.title}`}
          sizes={`${width}px`}
        />
      }
      classes={{
        tooltip: classes.imagePopover,
      }}
    >
      <Avatar
        aria-describedby={product.title}
        variant="rounded"
        classes={{
          root: `${classes.productAvatar} 
            ${
              product.id === currentProduct.id
                ? classes.currentItemBorder
                : classes.notCurrentItemBorder
            }`,
        }}
      >
        <Image
          style={{ objectFit: "cover" }}
          src={
            product.featuredImage?.node.thumbnail ||
            currentProduct.category.node.categoryDetails.fallbackImage
              ?.sourceUrl ||
            PLACEHOLDER_IMAGE_PATH
          }
          fill
          alt={`Thumbnail image of ${product.title}`}
          sizes="38px"
        />
      </Avatar>
    </Tooltip>
  );
}
